/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Users_Custom_Property1Inputs */

const en_tables_users_custom_property1 = /** @type {(inputs: Tables_Users_Custom_Property1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property1`)
};

const de_tables_users_custom_property1 = /** @type {(inputs: Tables_Users_Custom_Property1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property1`)
};

/**
* | output |
* | --- |
* | "Property1" |
*
* @param {Tables_Users_Custom_Property1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_users_custom_property1 = /** @type {((inputs?: Tables_Users_Custom_Property1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Users_Custom_Property1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_users_custom_property1(inputs)
	return de_tables_users_custom_property1(inputs)
});